__webpack_require__.p = "/math-magicians/";